"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAIN_BANNERS = exports.MainSlider = void 0;
var MainSlider_1 = require("./MainSlider");
Object.defineProperty(exports, "MainSlider", { enumerable: true, get: function () { return __importDefault(MainSlider_1).default; } });
Object.defineProperty(exports, "MAIN_BANNERS", { enumerable: true, get: function () { return MainSlider_1.MAIN_BANNERS; } });
